var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({ref:"autocomplete",attrs:{"no-data-text":_vm.$t('NO_DATA_AVAILABLE'),"rules":_vm.required ? [_vm.validate] : [],"menu-props":{
    allowOverflow: true,
  }}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }